import React, { useContext } from 'react'
import { Card, Container, ListGroup } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import './styles.css';
import { TbTruckReturn } from "react-icons/tb";
import { IoIosArrowForward } from "react-icons/io";
import { SlPuzzle } from "react-icons/sl";
import { LiaFileInvoiceSolid } from "react-icons/lia";
import { MdSchedule } from "react-icons/md";
import { OrderContext } from '../../context/OrderContext';






const ReturnType = () => {


    const navigate = useNavigate();

    // const {invoiceProcess} = useContext(OrderContext); // Coming soon özellikler için comment'lendi
    const {process, uuid, orderProduct, refundProduct} = useContext(OrderContext); // İade talebi kontrolü için process kullanılıyor
    // const {setClaimType, missingProcess} = useContext(OrderContext); // Değişim için kullanılan değişkenler comment'lendi
    // const {startClaim} = useStartSingleClaim() // Coming soon özellikler için comment'lendi
  
      // Sadece iade aktif - değişim özelliği kullanılmıyor
      const handleReturn = () => {
        // Eğer zaten bir iade talebi varsa (process === true)
        if (process && uuid) {
          // Tüm ürünler için iade talebi adet bazlı tamamlanmış mı kontrol et
          const allOrderProducts = orderProduct?.OrderProducts || [];
          const refundClaims = Array.isArray(refundProduct) 
            ? refundProduct.filter((c) => c.type === 'İade Talebi')
            : [];
          
          // Her ürün için talep edilen toplam adedi topla
          const requestedByProductId = new Map();
          refundClaims.forEach(claim => {
            if (claim.items && Array.isArray(claim.items)) {
              claim.items.forEach(item => {
                const productId = item?.order_product?.Id;
                if (!productId) return;
                const qty = Number(item?.requested_quantity) || 0;
                requestedByProductId.set(productId, (requestedByProductId.get(productId) || 0) + qty);
              });
            }
          });
          
          // Siparişteki her ürün için talep edilen adet, ürün adedini karşılıyor mu?
          const allProductsClaimed = allOrderProducts.length > 0 && 
            allOrderProducts.every(product => {
              const requestedQty = requestedByProductId.get(product.Id) || 0;
              return requestedQty >= (Number(product.Count) || 1);
            });
          
          if (allProductsClaimed) {
            // Tüm ürünler için talep açılmışsa return-summary'ye git
            navigate('/return-summary');
          } else {
            // Bazı ürünler için talep açılmamışsa product-list'e git
            navigate('/product-list');
          }
        } else {
          // Yeni iade talebi açmak için product-list sayfasına yönlendir
          navigate('/product-list');
        }
      };
    
      // Coming soon - şu an kullanılmıyor
      // const handleMissingDelivery = () => {
      //       navigate('/missing-type');
      // };

      // Coming soon - şu an kullanılmıyor
      // const handleInvoiceRequest = () => {
      //   if (invoiceProcess) {
      //     navigate('/invoice-summary');
      //     } else {
      //       startClaim("3"); 
      //       navigate('/invoice-page');
      //   }
      // };

      // console.log('process', process) // Değişim için kullanılan log comment'lendi


  return (
    <Container className="d-flex justify-content-center align-items-center return-type-container">
    <Card className='card-box-1'> 
      <Card.Title className='card-title'>İade Merkezi</Card.Title>
      <ListGroup variant="flush">

        {/* Sadece iade aktif - değişim özelliği kullanılmıyor */}
        <ListGroup.Item action onClick={handleReturn}>
            <TbTruckReturn style={{ fontSize: '20px' }} className="me-2" /> 
            <span style={{ marginRight: '3px', fontWeight: 'bold' }}>İade</span>
            {process ? 'talebini görüntüle' : 'talebi açmak istiyorum'}
            <IoIosArrowForward className="float-end" /> 
          </ListGroup.Item>

          <ListGroup.Item className="coming-soon-item">
            <SlPuzzle className="option-icon me-2" /> 
            <div className="option-content">
              <span className="option-text">
                <span className="option-bold">Eksik/Teslim </span> 
                edilmeyen siparişim var
              </span>
              <span className="coming-soon-badge">
                <MdSchedule className="coming-soon-icon" />
                <span>Yakında</span>
              </span>
            </div>
            <IoIosArrowForward className="float-end option-arrow" /> 
          </ListGroup.Item>
        
          <ListGroup.Item className="coming-soon-item">
            <LiaFileInvoiceSolid className="option-icon me-2" /> 
            <div className="option-content">
              <span className="option-text">
                <span className="option-bold">Fatura</span> 
                {' '}talebi oluşturmak istiyorum
              </span>
              <span className="coming-soon-badge">
                <MdSchedule className="coming-soon-icon" />
                <span>Yakında</span>
              </span>
            </div>
            <IoIosArrowForward className="float-end option-arrow" /> 
          </ListGroup.Item>
        </ListGroup>
    </Card>
    </Container>
  )
}

export default ReturnType